export default __webpack_public_path__ + "static/home-banner-5052953ddb1831c2b316a9c2f9c4049f.jpg";